
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-virksomheder",
      function () {
        return require("private-next-pages/for-virksomheder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-virksomheder"])
      });
    }
  